import React from "react";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";

import Button from "@/components/button";
import { useModal } from "@/hooks/use-modal";

import { ButtonBar, Module } from "../../layouts/";
import { ButtonGroup } from "../../layouts/button-group";

import ModalTitle from "./modal-title";

export default function VerificationEmailSentModal() {
  const { closeModal } = useModal();

  return (
    <div className="text-center">
      <ModalTitle>Verification Email sent</ModalTitle>
      <Module>
        <p>
          An email has been sent. Please check your inbox and click the link in
          the email.
        </p>
        <p>
          You must verifiy the email address to be able to post on The Animator.
        </p>
      </Module>
      <ButtonBar>
        <ButtonGroup align="right">
          <Button
            icon={faCheckCircle}
            onClick={closeModal}
            type="positive"
            rightAlign
          >
            Ok
          </Button>
        </ButtonGroup>
      </ButtonBar>
    </div>
  );
}
